export default {
  namespaced: true,
  state: {
    isLoggingIn: false,
    isUnsubscribing: false
  },
  getters: {
    isLoggingIn (state: any) {
      return state.isLoggingIn
    },
    isUnsubscribing (state: any) {
      return state.isUnsubscribing
    }
  },
  actions: {
    showLogin (context: any) {
      context.commit('loginShowed')
    },
    hideLogin (context: any) {
      context.commit('loginHide')
    },
    showUnsub (context: any) {
      context.commit('unsubShowed')
    },
    hideUnsub (context: any) {
      context.commit('unsubHide')
    }
  },
  mutations: {
    loginShowed (state: any) {
      state.isLoggingIn = true
    },
    loginHide (state: any) {
      state.isLoggingIn = false
    },
    unsubShowed (state: any) {
      state.isUnsubscribing = true
    },
    unsubHide (state: any) {
      state.isUnsubscribing = false
    }
  }
}
